module.exports = __webpack_public_path__ + "img/triangle.f2d2e303.svg";